import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import AssetImage from '../image/AssetImage';
import * as userDataActions from '../../../actions/userDataActions';
import * as dialogPopupActions from '../../../actions/dialogPopupActions';
import * as appConstants from "../../../constants/appConstants";
import * as appHelper from '../../../helpers/appHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as keyboardConstants from '../../../constants/keyboardConstants';

import {ASSET_CONFIG} from '../../../models/dialogModels';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class ResourceImageLink extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            resource: this.props.resource,
            userData: this.props.userData,
            locale: appHelper.getLocalData(this.props.resource),
            required_label: appHelper.getLocaleString("required_label")
        };
        this.onOpen = this.onOpen.bind(this);
        this.getStatusClass = this.getStatusClass.bind(this);
        this.updateResourceObjectResult = this.updateResourceObjectResult.bind(this);
        this.onCloseAssetDialog = this.onCloseAssetDialog.bind(this);
        this.launchAsset = this.launchAsset.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);

    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        if(this.state.userData !== nextProps.userData){
            this.setState({userData: Object.assign({}, nextProps.userData)});
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.resource),
                required_label: appHelper.getLocaleString("required_label")
            });
        }
    }

    componentDidUpdate() {

    }

    onCloseAssetDialog(viewed){
        let objectUserData = userDataHelper.getAttachmentObjectUserData(this.state.userData, this.state.resource.asset_id);
        if(objectUserData.status !== objectConstants.STATUS_COMPLETE && viewed) {
            this.updateResourceObjectResult();
        }
    }

    launchAsset(){
        let childComponenents = [];
        let config = Object.assign({}, ASSET_CONFIG,
            {
                title: this.state.locale.label,
                onClose: this.onCloseAssetDialog,
                showCloseBtn: false,
                theme: "dialog-asset-image",
                sourceId: `resource_link_${this.state.resource.screen_id}`
            }
        );

        for (let i = 0; i < config.childComponents.length; i++) {
            let child = config.childComponents[i];
            child = Object.assign({},child,{
                childComponent: AssetImage,
                componentProps: Object.assign({}, {
                    screenObject: this.state.resource,
                    callbacks:{}

                })
            });

            childComponenents = dataHelper.immutablePush(childComponenents, child);
        }
        config = Object.assign({},config,{
            childComponents: childComponenents
        });

        this.props.actions.setNewAssetDialog(config);
    }

    getStatusClass(){
        let objectUserData = userDataHelper.getAttachmentObjectUserData(this.state.userData, this.state.resource.asset_id);
        if (objectUserData.status === objectConstants.STATUS_NOT_STARTED) {
            return "not-started";
        } else if (objectUserData.status === objectConstants.STATUS_IN_PROGRESS) {
            return "in-progress";
        } else if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
            return "complete";
        }
    }

    onOpen(){
       // this.updateResourceObjectResult();
        this.launchAsset();
    }

    updateResourceObjectResult(){
        let params ={
            asset_id: this.state.resource.asset_id,
            asset_type_code: this.state.resource.object_type,
            status: objectConstants.STATUS_COMPLETE,
        };

        this.props.actions.updateResourceObjectResult(params).then((userData) => {
            this.props.actions.setSuspendData(userData).then((trackingData) => {}).catch(error => {});
        }).catch(error => {
        });
    }

    setKeyboardAccessibility(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.onOpen();
        }
    }

    render() {
        return (
            <li className={`resource-link ${this.getStatusClass()}`}>
                <span className="image" onClick={this.onOpen} onKeyDown={this.setKeyboardAccessibility} role="link" tabIndex="0" id={`resource_link_${this.state.resource.screen_id}`}  dangerouslySetInnerHTML={{__html: this.state.locale.label}} />
                {this.state.resource.required
                    ?
                    <span className="required-label"> - {this.state.required_label}</span>
                    :
                    null
                }
            </li>
        );
    }
}

ResourceImageLink.propTypes = {
    resource: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

ResourceImageLink.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, userDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResourceImageLink);



/** WEBPACK FOOTER **
 ** ./src/components/objects/resourceLinks/ResourceImageLink.js
 **/